import { Volume } from "./components/volume";
import { Base } from "./volumes.base";

export const Volumes = Object.assign(Base, {
    Volume
});
